import { Button, IconButton, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import DoneIcon from '@mui/icons-material/Done';
import userProfile from '../../../assets/images/userProfile.svg';
import { ExpandMore } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useHook as UserManagementHook } from '../Iam/usermangement/useHook';
interface AssignDrawer {
  assignCloseDrawer: () => void;
  assignSubmit: (data: any) => void;
}
interface UserDataList {
  userID: string;
  userName: string;
  firstName: string;
  lastName: string;
  avatar: string;
}

const AssignUserDrawer: React.FC<AssignDrawer> = ({
  assignCloseDrawer,
  assignSubmit,
}) => {
  const [assignDealer, setAssignDealer] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<UserDataList[]>([]);
  const [selectedusername, setSelectedusername] = useState<any>(null);
  const { allUsers } = useSelector((state: any) => state.user);
  const [openUser, setOpenUser] = useState(false);
  const { fetchAllUserList } = UserManagementHook();
  const getUserData = async () => {
    await fetchAllUserList({});
  };

  useEffect(() => {
    setFilteredData(allUsers);
  }, [allUsers]);

  useEffect(() => {
    getUserData();
  }, []);

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: UserDataList[] = allUsers?.filter(
      (user: { firstName: any; lastName: any }) =>
        `${user.firstName + user.lastName}`.toLowerCase().includes(query),
    );
    setFilteredData(filtered);
  };

  const handleuser = (userData: any): void => {
    if (userData) {
      setSelectedusername(userData);
      setAssignDealer([userData]);
    } else {
      setSelectedusername(null);
    }
    setOpenUser(false), setFilteredData(allUsers);
  };
  const handleAssignChange = (event: any) => {
    const { name, value, type, checked } = event.target;
  };
  return (
    <>
      <div className="fliter-drawer-container">
        <div>
          <div className="fliter-drawer-header">
            <p className="fliter-drawer-header-content">Assign User</p>
          </div>

          <div className="fliter-drawer-body">
            <div className="drawer_selecte-div">
              <h6 className="drawer_selecte_content">User</h6>
              <Select
                open={openUser}
                onOpen={() => setOpenUser(true)}
                onClose={() => {
                  setOpenUser(false), setFilteredData(allUsers);
                }}
                className="drawer_input_select"
                multiple
                displayEmpty
                value={assignDealer}
                renderValue={() => (
                  <div className="selecter_dropdown_placeholder">
                    {!selectedusername ? (
                      'Select User'
                    ) : (
                      <div className="global_audilog_user_profile_cheked">
                        <img
                          src={
                            selectedusername?.avatar
                              ? selectedusername?.avatar
                              : userProfile
                          }
                          width={24}
                          alt="User Profile"
                        />{' '}
                        <p>{`${selectedusername?.firstName} ${selectedusername?.lastName}`}</p>
                      </div>
                    )}
                  </div>
                )}
                IconComponent={ExpandMore}
                onChange={handleAssignChange}
              >
                <div className="user_name-popover">
                  <div className="user_name-popover-search">
                    <TextField
                      className="user_name-popover-search_input search-input"
                      variant="outlined"
                      placeholder="Search user names here"
                      fullWidth
                      InputProps={{
                        startAdornment: <SearchIcon className="search_icon" />,
                      }}
                      onChange={handleUserSearch}
                    />
                  </div>
                  {filteredData.map((user, index) => (
                    <Button
                      key={index}
                      onClick={() => {
                        handleuser(user);
                      }}
                      className={
                        selectedusername?.userID === user?.userID
                          ? 'global_audilog_user user_checked'
                          : 'global_audilog_user'
                      }
                    >
                      <div className="global_audilog_user_profile">
                        <img
                          src={user?.avatar ? user?.avatar : userProfile}
                          width={24}
                          alt="User Profile"
                        />{' '}
                        <p>{`${user?.firstName} ${user?.lastName}`}</p>
                      </div>
                      {selectedusername?.userID === user?.userID && (
                        <IconButton className="iconButton">
                          <DoneIcon className="doneIcon" />
                        </IconButton>
                      )}
                    </Button>
                  ))}
                </div>
              </Select>
            </div>
          </div>
        </div>

        <div className="create_controller-nodata_drawer_button_content">
          <div className="create_controller-nodata_drawer_button">
            <Button
              variant="text"
              className="cencel_button"
              onClick={assignCloseDrawer}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className={
                selectedusername ? 'save_button' : 'save_button disabled_button'
              }
              disabled={!selectedusername}
              onClick={() => assignSubmit(selectedusername)}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const MemoizedComponent = React.memo(AssignUserDrawer);
export default MemoizedComponent;
